import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faXmark, faCircleCheck, faCircleExclamation,
    faIdCard, faLock, faFloppyDisk, faKey, faCircleUser,
} from '@fortawesome/free-solid-svg-icons';
import api from '../api/client';
import TwoFactorSection from './TwoFactorSection';

function StatusBanner({ status }) {
    if (!status) return null;
    return (
        <div className={`profile-modal__status ${status.ok ? 'is-ok' : 'is-error'}`}>
            <FontAwesomeIcon icon={status.ok ? faCircleCheck : faCircleExclamation} />
            {status.message}
        </div>
    );
}

function ProfileModal({ profile, onClose, onSaved }) {
    const [employeeName, setEmployeeName] = useState(profile?.employeeName || '');
    const [employeeSurname, setEmployeeSurname] = useState(profile?.employeeSurname || '');
    const email = profile?.email || '';
    const [phone, setPhone] = useState(profile?.phone || '');
    const [infoStatus, setInfoStatus] = useState(null);

    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [passwordStatus, setPasswordStatus] = useState(null);

    const saveInfo = (e) => {
        e.preventDefault();
        setInfoStatus(null);
        // email не отправляем: он ключ сопоставления для входа через Google,
        // менять его может только администратор (Epic 7).
        api.put(`/api/profile`, { employeeName, employeeSurname, phone })
            .then(r => {
                setInfoStatus({ ok: true, message: 'Saved' });
                onSaved?.(r.data);
            })
            .catch(err => setInfoStatus({ ok: false, message: err.response?.data?.error || 'Failed to save' }));
    };

    const savePassword = (e) => {
        e.preventDefault();
        setPasswordStatus(null);
        if (newPassword !== confirmPassword) {
            setPasswordStatus({ ok: false, message: 'New passwords do not match' });
            return;
        }
        api.put(`/api/profile/password`, { currentPassword, newPassword })
            .then(() => {
                setPasswordStatus({ ok: true, message: 'Password updated' });
                setCurrentPassword('');
                setNewPassword('');
                setConfirmPassword('');
            })
            .catch(err => setPasswordStatus({ ok: false, message: err.response?.data?.error || 'Failed to update password' }));
    };

    // Клик мимо карточки НЕ закрывает окно: в блоке 2FA показываются резервные
    // коды, которые видно ровно один раз, и случайный клик уничтожал бы их
    // безвозвратно. Закрытие — только крестиком.
    return (
        <div className="profile-modal__overlay">
            <div className="profile-modal__card">
                <div className="profile-modal__header">
                    <div className="profile-modal__header-title">
                        <FontAwesomeIcon icon={faCircleUser} className="profile-modal__header-avatar" />
                        <h3>Edit Profile</h3>
                    </div>
                    <button type="button" className="profile-modal__close" onClick={onClose}>
                        <FontAwesomeIcon icon={faXmark} />
                    </button>
                </div>

                <form className="profile-modal__section" onSubmit={saveInfo}>
                    <div className="profile-modal__section-title">
                        <span className="profile-modal__section-icon"><FontAwesomeIcon icon={faIdCard} /></span>
                        <h4>Your Info</h4>
                    </div>

                    <div className="profile-modal__grid">
                        <div className="profile-modal__row">
                            <label>First Name</label>
                            <input value={employeeName} onChange={e => setEmployeeName(e.target.value)} required />
                        </div>
                        <div className="profile-modal__row">
                            <label>Last Name</label>
                            <input value={employeeSurname} onChange={e => setEmployeeSurname(e.target.value)} />
                        </div>
                        <div className="profile-modal__row">
                            <label>Email</label>
                            <input type="email" value={email} readOnly disabled
                                title="Used for sign-in — ask an administrator to change it" />
                        </div>
                        <div className="profile-modal__row">
                            <label>Phone</label>
                            <input value={phone} onChange={e => setPhone(e.target.value)} />
                        </div>
                    </div>

                    <div className="profile-modal__footer">
                        <StatusBanner status={infoStatus} />
                        <button type="submit" className="profile-modal__save-btn">
                            <FontAwesomeIcon icon={faFloppyDisk} />
                            Save Info
                        </button>
                    </div>
                </form>

                <form className="profile-modal__section" onSubmit={savePassword}>
                    <div className="profile-modal__section-title">
                        <span className="profile-modal__section-icon"><FontAwesomeIcon icon={faLock} /></span>
                        <h4>Change Password</h4>
                    </div>

                    <div className="profile-modal__row">
                        <label>Current Password</label>
                        <input type="password" value={currentPassword} onChange={e => setCurrentPassword(e.target.value)} required />
                    </div>
                    <div className="profile-modal__grid">
                        <div className="profile-modal__row">
                            <label>New Password</label>
                            <input type="password" value={newPassword} onChange={e => setNewPassword(e.target.value)} required minLength={6} />
                        </div>
                        <div className="profile-modal__row">
                            <label>Confirm New Password</label>
                            <input type="password" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} required minLength={6} />
                        </div>
                    </div>

                    <div className="profile-modal__footer">
                        <StatusBanner status={passwordStatus} />
                        <button type="submit" className="profile-modal__save-btn">
                            <FontAwesomeIcon icon={faKey} />
                            Update Password
                        </button>
                    </div>
                </form>

                <TwoFactorSection />
            </div>
        </div>
    );
}

export default ProfileModal;
